import { useState } from 'react'
import { motion } from 'framer-motion'

type Props = {
	id: string
	title: string
	content: any
	collapsed?: boolean
}

export default function Collapsible({ id, title, content, collapsed }: Props ) {
	const [ open, setOpen ] = useState( !collapsed )
	return (
		<motion.section
			className="container"
			animate={open ? 'open' : 'closed'}
			aria-expanded={open ? 'true' : 'false'}
		>
			<span id={id} />
			<hr />
			<a
				onClick={() => setOpen( ( o ) => !o )}
				aria-controls={`${id}-text`}
			>
				{title}
			</a>
			<motion.div
				style={{ overflow: 'hidden' }}
				variants={{
					open: { height: 'auto', opacity: 1 },
					closed: { height: 0, opacity: 0 },
				}}
				id={`${id}-text`}
				aria-hidden={!open ? 'true' : 'false'}
			>
				<div className="text">{content}</div>
			</motion.div>
			<hr />
			<style jsx>{`
				:global( section[aria-expanded] ) {
					margin-top: 10vw;
				}
				@media ( max-width: 700px ) {
					:global( section[aria-expanded] ) {
						margin-top: 0;
					}
				}
				:global( section[aria-expanded] + section[aria-expanded] ) {
					margin-top: -1px;
				}
				span:empty {
					position: relative;
					top: -100px;
				}
				hr {
					margin: 0;
					border: none;
					border-top: 1px solid #dedee2;
				}
				a {
					display: block;
					padding: .9em 0;
					font-size: 51px;
					cursor: pointer;
					position: relative;
				}
				a::after {
					pointer-events: none;
					content: '+';
					position: absolute;
					right: 0;
				}
				:global( section[aria-expanded=true] > a::after ) {
					content: '–';
				}
				@media ( max-width: 700px ) {
					a {
						font-size: 8vw;
					}
				}
				.text {
					padding: 10vw 0;
					display: grid;
					grid-column-gap: 8vw;
					grid-auto-flow: row;
				}
				.text :global(> div) {
					display: contents;
				}
				.text :global(h2) {
					margin-bottom: 0;
				}
				.text :global(h2:first-child) {
					margin-bottom: 1em;
				}
				.text :global(h3:first-child) {
					margin-top: 0;
				}
				.text :global(section.container),
				.text :global(section.cf),
				.text :global(section.cf .products) {
					margin: 0;
					padding: 0;
				}
				.text :global(section.container),
				.text :global(section.cf) {
					grid-column: span 2;
				}

				@media ( min-width: 700px ) {
					.text {
						padding: 100px 0;
						grid-template-columns: 1fr 1fr;
					}
					.text :global(> div > *),
					.text :global(> div + *) {
						grid-column: 2/3;
					}
					.text :global(h2:first-child) {
						grid-column: 1/2;
						grid-row: span 3;
					}
					.text :global(h2:first-child + *) {
						margin-top: 0;
					}
				}
			`}</style>
		</motion.section>
	)
}
